import Deferred from "../models/deferred";

export default {
  cachedContent: {},
  getCachedContentDetails: function(contentID){
    return this.cachedContent[contentID];
  },
  getContentDetails: function(contentID){
    const def = new Deferred();
    var api = this;
    Flybits.api.Content.get(contentID).then(function(res){
      api.cachedContent[res.result.id] = res.result;
      def.resolve(res.result);
    }).catch(function(e){
      def.reject(e);
    })

    return def.promise;
  },
  getZoneContent: function(refID){
    const def = new Deferred();
    var contentMap = this.cachedContent;

    Flybits.api.Zones.getByReferenceId(refID).then(function(zoneConfig){
      if(!zoneConfig?.zone?.modules){
        def.reject(new Flybits.Validation().addError('Zone not found','No valid Zone was found with specified reference ID',{
          code: Flybits.Validation.type.NOTFOUND,
          context: refID
        }));
      } else{
        zoneConfig.zone.modules.forEach(function(module){
          module.content.forEach(function(c){
            contentMap[c.id] = c;
          });
        });
        def.resolve(zoneConfig.zone);
      }
    }).catch(function(e){
      def.reject(e);
    });

    return def.promise;
  },
}